import React, { useState, useEffect } from 'react';
import { FaTwitter, FaInstagram, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './PostDeck.css';




function PostCard({ platform, post, keyword }) {
  const [isExpanded, setIsExpanded] = useState(false); // State for toggling content expansion
  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleString();
  };

  const PlatformIcon = platform === 'twitter' ? FaTwitter : FaInstagram;

  const renderPostImages = (images) => {
    if (!images) return null;

    // Normalize images to be an array
    if (!Array.isArray(images)) {
      images = [images];
    }

    return (
      <div className="post-images-container">
        {images.map((url, index) => (
          <img
            key={index}
            src={url}
            alt={`${index + 1}`}
            style={{ maxWidth: "100%", borderRadius: "8px", margin: "5px" }}
          />
        ))}
      </div>
    );
  };

  const highlightText = (text, keyword) => {
    if (!keyword) return text; // If no keyword, return the original text

    const parts = text.split(new RegExp(`(${keyword})`, 'gi')); // Split text by keyword and retain the keyword itself
    return parts.map((part, index) => 
      part.toLowerCase() === keyword.toLowerCase() ? 
      <span key={index} className="highlight">{part}</span> : 
      part
    );
  };

  const highlightedContent = highlightText(post.text, keyword);

  if (platform === 'twitter') {
    return (
      <div className={`location-post-card ${platform}`}>
        <div className="location-post-header">
          <img 
            src={`https://unavatar.io/twitter/${post.author_username}`} 
            alt="user" 
            className="location-user-avatar" 
          />
          <div className="location-user-info">
            <h4>@{post.author_username}</h4>
            <span>{formatDate(post.timestamp)}</span>
            {/* {post.place_full_name && (
              <span className="location-location">{post.place_full_name}</span>
            )} */}
          </div>
        </div>
        <p className={`location-post-content ${isExpanded ? 'expanded' : ''}`}>
        {highlightedContent}
      </p>  {/* Use the highlighted content */}
      <span 
        className="location-read-more" 
        onClick={() => setIsExpanded(prev => !prev)}>
        {isExpanded ? 'Read less' : 'Read more'}
      </span>
        {renderPostImages(post.attached_media_display_url)} 
        <div className="location-post-footer">
          <span className="location-platform-tag">
            <PlatformIcon />
            Twitter
          </span>
          
        </div>
      </div>
    );
  }

  if (platform === 'instagram') {
    return (
      <div className={`location-post-card ${platform}`}>
        <div className="location-post-header">
          <img 
            src={`icons/profiling2.png`} 
            alt="user" 
            className="location-user-avatar" 
          />
          <div className="location-user-info">
            <h4>{post.owner_username}</h4>
            <span>{post.timestamp}</span>
          </div>
        </div>
        <p className="location-post-content">{highlightedContent}</p> {/* Use the highlighted content */}
        <span 
        className="location-read-more" 
        onClick={() => setIsExpanded(prev => !prev)}>
        {isExpanded ? 'Read less' : 'Read more'}
      </span>
        {renderPostImages(post.attached_media_display_url)} 
        <div className="location-post-footer">
          <span className="location-platform-tag">
            <PlatformIcon />
            Instagram
          </span>

        </div>
      </div>
    );
  }

  return null;
}

function PostDeck({ fetchedData }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [isCollapsed, setIsCollapsed] = useState(
    JSON.parse(localStorage.getItem("isCollapsed")) || false
  );
  const [keyword, setKeyword] = useState(""); // State to store the search keyword
  useEffect(() => {
    localStorage.setItem("isCollapsed", JSON.stringify(isCollapsed));
  }, [isCollapsed]);
  
  useEffect(() => {
    localStorage.setItem("keyword", keyword);
  }, [keyword]);
  
  useEffect(() => {
    const loadPosts = () => {
      const combinedPosts = fetchedData.map(post => {
        let platform = "unknown";
  
        if (post.platform) {
          platform = post.platform.toLowerCase();
        } else {
          // fallback detection based on field names
          if (post.author_username) platform = "twitter";
          if (post.owner_username) platform = "instagram";
        }
  
        return {
          platform,
          post
        };
      });
  
      setPosts(combinedPosts);
      setLoading(false);
    };
  
    loadPosts();
  }, [fetchedData]);
  
  
  const handleSearchChange = (e) => {
    setKeyword(e.target.value.toLowerCase()); // Update the search keyword based on user input
  };

  const filteredPosts = posts.filter(post => 
    post.post.text.toLowerCase().includes(keyword)
  ); // Filter posts based on the search keyword

  if (loading) {
    return (
      <div className="location-post-deck">
        <div className="location-loading">Loading posts...</div>
      </div>
    );
  }


  return (
    <div className={`location-post-deck ${isCollapsed ? 'collapsed' : ''}`}>
      <h2>
      Recent Posts
      </h2>

       <input // Search bar for filtering posts
            type="text"
            placeholder="Search posts..."
            className="post-search-input"
            onChange={handleSearchChange}
          />
          <div className="location-posts-container">
            
            {filteredPosts.map((post, index) => (
              <PostCard
                key={index} 
                platform={post.platform} 
                post={post.post} 
                keyword={keyword} // Pass the search keyword for highlighting
              />
            ))}
          </div>
      {/* {!isCollapsed && (
        <>
          
            <button className="location-toggle-btn" onClick={() => setIsCollapsed(true)}>
              <FaChevronRight />
            </button>
         
        </>
      )} */}
      {/* {isCollapsed && (
        <button className="location-toggle-btn" onClick={() => setIsCollapsed(false)}>
          <FaChevronLeft />
        </button>
      )} */}
    </div>
  );
}

export default PostDeck;
